// extracted by mini-css-extract-plugin
module.exports = {"footer_main":"Footer_footer_main__2vn92","footer_wrapper":"Footer_footer_wrapper__2emym","active":"Footer_active__3wB70"};